import { makeObservable, computed } from "mobx";

export default class AuditRegistryPermissionStore {
  constructor(parentStore) {
    makeObservable(this, {
      subscriber: computed,
      processing: computed,
      actions: computed,
      isCoordinator: computed,
      isAccountable: computed,
      isResponsible: computed,
      isConsulted: computed,
      isInformed: computed,
      isWellKnownSubscriptionType: computed,
      hasSubscriptions: computed,
    });

    this.parentStore = parentStore;
  }

  get hasSubscriptions() {
    const user = this.parentStore.parentStore.parentStore.authenticationStore.user;
    if (!user) {
      return null;
    }
    return this.parentStore.subscriberSummaryStore.summary?.subscriptions.length > 0;
  }

  get processing() {
    return this.loading;
  }

  get subscriber() {
    const user = this.parentStore.parentStore.parentStore.authenticationStore.user;
    if (!user) {
      return null;
    }
    return this.parentStore.subscriberSummaryStore.summary;
  }

  get isCoordinator() {
    return this.subscriber != null && this.subscriber.subscriptions.findIndex((x) => x.type === "coordinator") !== -1;
  }

  get isAccountable() {
    return this.subscriber != null && this.subscriber.subscriptions.findIndex((x) => x.type === "accountable") !== -1;
  }

  get isResponsible() {
    return this.subscriber != null && this.subscriber.subscriptions.findIndex((x) => x.type === "responsible") !== -1;
  }

  get isConsulted() {
    return this.subscriber != null && this.subscriber.subscriptions.findIndex((x) => x.type === "consulted") !== -1;
  }

  get isInformed() {
    return this.subscriber != null && this.subscriber.subscriptions.findIndex((x) => x.type === "informed") !== -1;
  }

  get isWellKnownSubscriptionType() {
    const roles = ["coordinator", "accountable", "responsible", "consulted", "informed"];
    return (
      this.subscriber != null && this.subscriber.subscriptions.findIndex((x) => roles.indexOf(x.type) !== -1) !== -1
    );
  }

  get actions() {
    const list = [];
    if (!this.type) {
      return list;
    }

    return list;
  }
}
